module.exports = __webpack_public_path__ + "static/media/medicine.f46e4bfb.png";